export default "__VITE_ASSET__DwaKBOpe__"